(() => {
  if (window.knotsBookingInitialized) return;
  window.knotsBookingInitialized = true;

  function updateBooking(block) {
    const scope = block.closest('.productView') || document.getElementById(`shopify-section-${block.dataset.sectionId}`);
    if (!scope) return;
    const form = document.getElementById(`product-form-${block.dataset.productId}`) || scope.querySelector('form[action*="/cart/add"]');
    const selector = scope.querySelector('variant-selects, variant-radios');
    const id = form?.querySelector('[name="id"]')?.value || selector?.currentVariant?.id || block.dataset.initialVariant;
    const variants = JSON.parse(block.querySelector('[data-booking-variants]').textContent);
    const variant = variants.find(item => String(item.id) === String(id));
    if (!variant) return;
    const input = form?.querySelector('[name="quantity"]') || scope.querySelector('[name="quantity"]');
    const quantity = Math.max(1, Math.floor(Number(input?.value) || 1));
    const total = variant.price * quantity;
    const advance = Math.ceil(total / 2);
    const format = new Intl.NumberFormat(block.dataset.locale || 'en-PK', {
      style: 'currency', currency: block.dataset.currency || 'PKR', currencyDisplay: 'code'
    });
    [['total', total], ['advance', advance], ['balance', total - advance]].forEach(([name, amount]) => {
      block.querySelector(`[data-booking-${name}]`).textContent = format.format(amount / 100);
    });
  }

  function refresh(target) {
    document.querySelectorAll('[data-knots-booking]').forEach(block => {
      const scope = block.closest('.productView');
      if (!target || scope?.contains(target)) updateBooking(block);
    });
  }

  document.addEventListener('change', event => refresh(event.target));
  document.addEventListener('input', event => {
    if (event.target.matches('[name="quantity"]')) refresh(event.target);
  });
  document.addEventListener('shopify:section:load', () => refresh());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh());
  else refresh();
})();
